import { apiEndpoints } from '@/lib/api/endpoints'
import type { ProductDetailPage } from '@/types/interfaces/productDetailPage'
import { baseApi } from './baseQuery'

export const productDetailPageApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getProductDetailPage: builder.query<ProductDetailPage, string>({
            query: (skuId) => apiEndpoints.productDetailPages.getBySkuId(skuId),
            providesTags: (_result, _error, skuId) => [{ type: 'ProductDetailPage', id: skuId }],
        }),
    }),
    overrideExisting: false,
})

export const { useGetProductDetailPageQuery } = productDetailPageApi
